import { Routes } from '@angular/router';
import { homeRouteConfig } from './home/home-route-config';
import { BaseComponent } from './base.component';

export const baseRouteConfig: Routes = [
	{
		path: '',
		component: BaseComponent,
		children: [
			{
				path: 'principal',
				children: homeRouteConfig,
				data: {
					breadcrumb: {
						label: 'Principal',
						link: false
					}
				}
			},
			{
				path: '',
				loadChildren: () => import('./legacy-page/legacy-page.module').then( mod => mod.LegacyPageModule )
			}
		],
	}
];

